export default "__VITE_ASSET__CU_fFDu1__"